import { ICreateContract, IUpdateContract } from "@/interfaces/contracts.interface"
import { ContractFormData, contractSchema } from "../components/form-contrato/schemas"
import { zodResolver } from "@hookform/resolvers/zod"
import { useForm } from "react-hook-form"

type MapContratoPayloadExtra = { id?: number }

export function parseCurrencyToNumber(value: string): number {
  if (!value) return 0
  const normalized = value.replace(/\./g, "").replace(",", ".")
  const parsed = parseFloat(normalized)
  return isNaN(parsed) ? 0 : parsed
}

export function normalizeDateToString(date: Date | string | undefined): string {
  if (!date) return ""
  if (typeof date === "string") return date
  return date.toISOString()
}

export function formatDateUtcToLocal(dateString: string): string {
  if (!dateString) return ""
  const datePart = dateString.split("T")[0]
  const [year, month, day] = datePart.split("-")
  return `${day}/${month}/${year}`
}

export function mapContratoFormToPayload(
  data: ContractFormData,
  movieId: number,
  extra?: MapContratoPayloadExtra
): ICreateContract | IUpdateContract {
  const hasCopyright = data.has_copyright === "true"

  const totalAmount = parseCurrencyToNumber(String(data.total_amount ?? ""))

  return {
    ...(extra?.id && { id: extra.id }),
    movieId,
    email: data.email ?? "",
    name: data.name ?? "",
    document: data.document ?? "",
    role: data.role ?? "",
    contract_description: data.contract_description ?? "",
    uploaded_contract_url: data.uploaded_contract_url,
    contract_till: normalizeDateToString(data.contract_till as Date | string),
    total_amount: totalAmount,
    month_amount: totalAmount ? totalAmount / 12 : 0,
    amount_paid_till_now: totalAmount,
    active: true,
    id_testment_one: data.id_testment_one,
    id_testment_two: data.id_testment_two,
    has_copyright: hasCopyright,
    copyright_type: hasCopyright
      ? data.copyright_type ?? "PATRIMONIAL"
      : undefined,
    rlp_participation_percent: hasCopyright
      ? Number(data.rlp_participation_percent) || 0
      : undefined,
    credits_attribution: data.credits_attribution,
    biblioteca_nacional_reg: data.biblioteca_nacional_reg,
    cnae_codes: data.cnae_codes,
    service_code: data.service_code,
    drt_number: data.drt_number,
    cane_registration: data.cane_registration,
  }
}

export function initFormContrato(movieId: number) {
  const form = useForm<ContractFormData>({
      resolver: zodResolver(contractSchema),
      defaultValues: {
        movieId,
        email: "",
        name: "",
        document: "",
        role: "",
        contract_description: "",
        contract_till: "",
        total_amount: "",
        payment_method: "",
        location: "",
        signature_date: "",
        contract_start: "",
        active: true,
        has_copyright: "false",
      },
    })
  return form;
}
